import { type AnyZodObject, type ZodIssue } from 'zod'
import { computed, ref, type Ref } from 'vue'

export const useFormValidation = <T>(schema: AnyZodObject, data: Ref<T>) => {
  const getIsStepValid = ref((key?: keyof typeof data.value) =>
    key
      ? computed(() => schema.partial().safeParse({ [key]: data.value[key] }))
      : computed(() => schema.safeParse(data.value)),
  )

  const formatError = ref((errors: ZodIssue[] | undefined) => {
    const formatedErrors: Record<string, string> = {}

    if (errors) {
      errors.forEach((error) => {
        formatedErrors[error.path.join('-')] = error.message
      })
    }

    return formatedErrors
  })

  const stepHasBeenSubmitted = ref(false)

  return { stepHasBeenSubmitted, getIsStepValid, formatError }
}
